export const FETCH_INCOME_EVENTS = 'FETCH_INCOME_EVENTS';
export const FETCH_INCOME_EVENTS_SUCCESS = 'FETCH_INCOME_EVENTS_SUCCESS';
export const FETCH_INCOME_EVENTS_ERROR = 'FETCH_INCOME_EVENTS_ERROR';

export const fetchIncomeEvents = () => ({ type: FETCH_INCOME_EVENTS });
export const fetchIncomeEventsSuccess = (payload: any) => ({ type: FETCH_INCOME_EVENTS_SUCCESS, payload });
export const fetchIncomeEventsError = (payload: any) => ({ type: FETCH_INCOME_EVENTS_ERROR, payload });
